import React, { Component } from "react";
import { Navbar, Nav, NavDropdown, Image, Form, Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { isVignanContext } from "../../utils/vignan";
import {
  EXAM_TYPES,
  getExamTypeKey,
  getExamTypeLabel,
  setExamTypeKey,
} from "../../../utils/examScope";
import {
  filterAuthorizedBranches,
  getSelectedBranchIds,
  setSelectedBranchIds,
  SELECTED_BRANCH_COOKIE,
} from "../../../utils/branchScope";
import CheckboxDropdown from "../common/CheckboxDropdown";

import "./_navbar.scss";
// const FETCH_NOTIFYSTUDENTS = gql`
// query($institution_id: Int!) {
//     getInstituteNotificaton(institution_id: $institution_id){
//         title
//         description
//         class_ids
//         category_ids
//         branch_ids
//         section_ids

//     }
// }

// `;

class NavbarOne extends Component {
  // Change the GLOBAL exam-type filter. Persists to cookie + broadcasts so
  // pages listening via onExamTypeChange() refetch; also nudges a re-render so
  // the header label updates immediately.
  selectExamType = (key) => {
    setExamTypeKey(key);
    this.forceUpdate();
  };

  // branchSel holds the ticked branch ids. It must live in state, NOT be derived
  // from the cookie on every render: the cookie stores "" for All, but the dropdown
  // also emits [] when you untick the last box — deriving would read that [] back as
  // All and instantly re-tick everything, so clicks appeared to do nothing.
  // null = not chosen yet this session (fall back to the cookie, else all branches).
  state = { branchSel: null };

  // Change the GLOBAL branch filter. Same contract as selectExamType: persist to
  // cookie + broadcast so pages listening via onBranchScopeChange() refetch.
  //
  // The tick state is whatever the user clicked — including none, so "Select All"
  // toggles off properly. Both "none ticked" and "all ticked" persist as an empty
  // cookie, i.e. NO narrowing, matching the app's existing filter convention
  // (an empty multi-select means "don't filter"); the dropdown then shows its
  // "All Branches" placeholder, so an empty box never reads as "no data".
  selectBranches = (ids, allOptions) => {
    const all = (allOptions || []).map((o) => o.value);
    const next = ids || [];
    this.setState({ branchSel: next });
    setSelectedBranchIds(next.length === all.length ? [] : next);
  };

  // GLOBAL branch scope — multi-select in the header, remembered across pages via the
  // selected_branch_ids cookie (see utils/branchScope). Only branches this user is
  // authorized for are listed; hidden entirely when there's fewer than two to choose from.
  renderBranchScope() {
    const bq = this.props.getBranches || {};
    const options = filterAuthorizedBranches(bq.getBranches || []).map((b) => ({
      value: String(b.id),
      label: b.branch_name,
    }));
    if (options.length < 2) return null;

    // Live selection wins; otherwise seed from the cookie, and an empty cookie (= All)
    // ticks every box.
    const stored = getSelectedBranchIds();
    const value =
      this.state.branchSel !== null
        ? this.state.branchSel
        : stored.length
          ? stored
          : options.map((o) => o.value);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "#6b7280",
            whiteSpace: "nowrap",
          }}
        >
          Branch
        </span>
        <div style={{ minWidth: "200px", maxWidth: "280px" }}>
          <CheckboxDropdown
            options={options}
            value={value}
            onChange={(ids) => this.selectBranches(ids, options)}
            placeholder="All Branches"
          />
        </div>
      </div>
    );
  }

  logout = () => {
    console.log(
      "Navbarone",
      Cookies.get("institutionid"),
      Cookies.get("token"),
    );
    if (Cookies.get("token") !== undefined) {
      Cookies.remove("token");
      Cookies.remove("username");
      Cookies.remove("refreshtoken");
      Cookies.remove("email");
      Cookies.remove("id");
      Cookies.remove("institutionid");
      //Cookies.remove("fullname");
      Cookies.remove("userlevel");
      Cookies.remove("name");
      // The header's branch scope is per-user. Left behind, the next person to
      // sign in on this browser inherits it — and if they aren't authorized for
      // those branches, every page reads as empty. getSelectedBranchIds() also
      // guards against this on read, for sessions that end without a logout.
      Cookies.remove(SELECTED_BRANCH_COOKIE);
    }
    // Vignan users go straight back to the Vignan-branded (role) login; everyone
    // else to the standard login. Both are served at /login.
    this.props.history.push(isVignanContext() ? "/login?vignan=1" : "/login");
  };
  render() {
    console.log("Navbarone", this.props);
    const getOrganisationProfile = this.props.getOrganisationProfile;
    const loading3 = getOrganisationProfile.loading;
    const error3 = getOrganisationProfile.error;

    // const getInstituteNotificaton = this.props.getInstituteNotificaton;
    // const loading2 = getInstituteNotificaton.loading;
    // const error2 = getInstituteNotificaton.error;

    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }
    // if (error2 !== undefined) {
    //   alert("Server Error. " + error2.message);
    //   return null;
    // }
    if (loading3) return null;

    let orgname = "INSTITUTION NAME";
    let logo = "";

    if (this.props.getOrganisationProfile.getOrganisationProfile != null) {
      orgname = getOrganisationProfile.getOrganisationProfile.organisation_name;
      logo = getOrganisationProfile.getOrganisationProfile.logo;
    }

    // if (
    //   Cookies.get("token") == undefined ||
    //   Cookies.get("institutionid") == undefined
    // ) {
    //   this.props.history.push("/");
    //   //this.logout();
    // }
    //const notification = getInstituteNotificaton.getInstituteNotificaton;

    return (
      <>
        <style>{`
          .header-top .dropdown-menu {
            position: absolute !important;
            top: 100% !important;
            right: 0 !important;
            left: auto !important;
            transform: none !important;
          }
        `}</style>
        <Navbar
          style={{
            background: "white",
            borderBottom: "1px solid #e5e7eb",
            padding: "5px 20px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
          className="header-top"
        >
          <Button
            style={{
              background: "#f3f4f6",
              border: "none",
              color: "#374151",
              borderRadius: "8px",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
            onClick={() => this.props.onClick()}
          >
            <i className="fal fa-bars" />
          </Button>
  {/* 
          {this.props?.location?.back != undefined
            ? this.props?.location?.pathname !== "/" && (
                <Link to={this.props?.location?.back}>
                  <Button
                    style={{
                      background: "#f3f4f6",
                      border: "none",
                      color: "#374151",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    <i className="mr-2 fal fa-long-arrow-left" /> Back
                  </Button>
                </Link>
              )
            : this.props?.location?.pathname !== "/" && (
                <Link to="/">
                  <Button
                    style={{
                      background: "#f3f4f6",
                      border: "none",
                      color: "#374151",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    <i className="mr-2 fal fa-long-arrow-left" /> Back
                  </Button>
                </Link>
              )} */}
  
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div
              className="mr-auto d-flex align-items-center"
              style={{ gap: "12px" }}
            >
              <h4
                style={{
                  fontSize: "18px",
                  fontWeight: "800",
                  color: "#1f2937",
                  margin: 0,
                  textTransform: "uppercase",
                }}
              >
                {orgname}
              </h4>

            </div>
  
            <Nav className="ml-auto" style={{ gap: "8px", alignItems: "center" }}>
              {this.renderBranchScope()}
  
              <NavDropdown
                id="basic-nav-dropdown2"
                className="no-arrow"
                alignRight
                title={
                  <div
                    className="d-flex align-items-center"
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      background: "#f3f4f6",
                      border: "1px solid #e5e7eb",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#e5e7eb";
                      e.currentTarget.style.borderColor = "#d1d5db";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#f3f4f6";
                      e.currentTarget.style.borderColor = "#e5e7eb";
                    }}
                  >
                    <Image
                      src={require("../../../images/businessman.png")}
                      roundedCircle
                      alt="profile-img"
                      style={{
                        width: "32px",
                        height: "32px",
                        border: "2px solid white",
                      }}
                    />
                    <div style={{ marginLeft: "10px", marginRight: "8px" }}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#1f2937",
                        }}
                      >
                        {Cookies.get("name")}
                      </div>
                    </div>
                    <i
                      className="fal fa-chevron-down"
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                      }}
                    />
                  </div>
                }
              >
                <NavDropdown.Item
                  style={{
                    fontSize: "13px",
                    color: "#6b7280",
                    padding: "8px 16px",
                  }}
                >
                  {Cookies.get("email")}
                </NavDropdown.Item>
                <NavDropdown.Divider style={{ margin: "6px 0" }} />
                <NavDropdown.Item
                  as={Link}
                  to="/settings/organization-profile"
                  style={{
                    fontSize: "14px",
                    color: "#1f2937",
                    padding: "8px 16px",
                  }}
                >
                  <i className="far fa-user mr-2" style={{ color: "#3d66f5" }} />
                  My Profile
                </NavDropdown.Item>
                <NavDropdown.Divider style={{ margin: "6px 0" }} />
                <NavDropdown.Item
                  as={Link}
                  onClick={this.logout}
                  style={{
                    fontSize: "14px",
                    color: "#ef4444",
                    padding: "8px 16px",
                  }}
                >
                  <i className="far fa-sign-out mr-2" />
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </>
    );
  }
}

export default withRouter(
  compose(
    graphql(
      gql`
        query ($institution_id: Int!) {
          getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name

            logo
          }
        }
      `,
      {
        options: (props) => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
        }),
        name: "getOrganisationProfile",
      },
    ),
    // Branch list for the header's global branch multi-select. Filtered to the
    // user's authorized branches client-side (filterAuthorizedBranches) before render.
    graphql(
      gql`
        query ($institution_id: Int!) {
          getBranches(institution_id: $institution_id) {
            id
            branch_name
          }
        }
      `,
      {
        options: () => ({
          variables: { institution_id: parseInt(Cookies.get("institutionid")) },
          fetchPolicy: "cache-first",
        }),
        name: "getBranches",
      },
    ),
    // graphql(FETCH_NOTIFYSTUDENTS,
    //   {
    //     options: props => ({
    //       variables: {
    //         institution_id: parseInt(Cookies.get("institutionid"))
    //       }
    //     }), name: "getInstituteNotificaton"
    //   })
  )(NavbarOne),
);
